import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useSelector } from 'react-redux'
import { selectServiceLocations } from '@user/store/map'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import ChevronRight from '@mui/icons-material/ChevronRight'

type Props = {
  onViewClick: () => void
  onClose: () => void
  showCloseBtn?: boolean
  formattedAddress?: string
}

export function MapBubbleMultiTenantContents(props: Props) {
  const { onViewClick, onClose, showCloseBtn, formattedAddress } = props
  const selectedServiceLocations = useSelector(selectServiceLocations)

  return (
    <Stack sx={{ userSelect: 'none' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">Multiple Records</Typography>

        {showCloseBtn && (
          <IconButton
            onClick={onClose}
            size={'small'}
            sx={{
              color: (theme) => theme.palette.action.active,
              cursor: 'pointer',
              borderRadius: '100px',
            }}
            data-testid="action-modal-close-btn"
            data-test-id="mapBubbleMultiTenantCloseBtn"
          >
            <CloseIcon fontSize={'small'} />
          </IconButton>
        )}
      </Stack>

      <Box mt="4px" mb="11px">
        {formattedAddress && (
          <Typography variant="body2" mb={1}>
            {formattedAddress}
          </Typography>
        )}

        <Alert severity="info">
          <Typography variant="body2">
            {selectedServiceLocations.length} records found for this location.
          </Typography>
        </Alert>
      </Box>

      <Button
        variant="contained"
        onClick={onViewClick?.bind(null)}
        sx={{ width: '100%' }}
      >
        View Records
        <ChevronRight sx={{ fontSize: '20px', ml: '8px', mt: '1px' }} />
      </Button>
    </Stack>
  )
}
